import type { ComponentProps } from "react"
import { Switch as SwitchPrimitive } from "radix-ui"

import { cn } from "../lib/cn"

function Switch({ className, ...props }: ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border border-transparent bg-input outline-none transition-colors focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary", // anti-ia-ok: a forma de trilha é a do alternador que todos reconhecem (Nielsen #2), exceção do story-book-dtf
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className="pointer-events-none block size-4 rounded-full bg-background shadow-none ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0.5" // anti-ia-ok: o botão redondo do alternador, exceção do story-book-dtf
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
